export type PaymentStatus = 'paid' | 'partial' | 'pending' | 'overdue' | 'voided' | 'payment_processing' | 'no_invoice';

/**
 * Friendly, human-readable label for a payment/invoice status. Replaces the
 * raw enum value (e.g. "pending", "PARTIAL") that used to leak into the UI.
 * Pure function — pair with useStatusLabel() for the bilingual version.
 */
export function getStatusLabel(status: string): string {
  switch ((status || '').toLowerCase()) {
    case 'paid':               return 'Paid';
    case 'partial':            return 'Partially Paid';
    case 'pending':            return 'Unpaid';
    case 'overdue':            return 'Overdue';
    case 'voided':             return 'Voided';
    case 'payment_processing': return 'Payment Processing';
    case 'no_invoice':         return 'No Invoice';
    default:
      return (status || '').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  }
}

export function getStatusColor(status: string): string {
  switch ((status || '').toLowerCase()) {
    case 'paid':
      return 'bg-green-100 text-green-800';
    case 'partial':
      return 'bg-blue-100 text-blue-800';
    case 'pending':
      return 'bg-yellow-100 text-yellow-800';
    case 'payment_processing':
      return 'bg-blue-100 text-blue-800';
    case 'overdue':
      return 'bg-red-100 text-red-800';
    case 'voided':
      return 'bg-gray-200 text-gray-700';
    case 'no_invoice':
    default:
      return 'bg-gray-100 text-gray-800';
  }
}


